import React, { useState } from 'react';
import { Divider, Dropdown, Grid } from 'semantic-ui-react';

import {
  NotificationsPageWrapper,
  SelectWrapper,
  StepCard,
  Subtitle,
  Title
} from './styles';
import { FieldLabel } from '../../styles';
import { AvailableBrokersAndEstatesState } from '../../store/types/temp-types';
import { iRootDispatch, iRootState } from '../../store';
import { connect } from 'react-redux';
import AnalysisStep from './components/analysis';
import ProposalsStep from './components/proposals';
import PolicyStep from './components/policy';
import Capitalizationtep from './components/capitalization';
import FireInsuranceStep from './components/fireInsurance';
import ClaimStep from './components/claim';

type Props = {
  availableBrokersAndEstates: AvailableBrokersAndEstatesState;
};

const MenuSelector: React.FC<{ step: number; setStep: (s: number) => void }> = ({
  step,
  setStep
}) => {
  return (
    <Grid.Row>
      <Grid.Column width={1}>
        <StepCard
          active={step === 1}
          onClick={() => {
            setStep(1);
          }}
        >
          <span>Análise</span>
        </StepCard>
      </Grid.Column>
      <Grid.Column width={1}>
        <StepCard
          active={step === 2}
          onClick={() => {
            setStep(2);
          }}
        >
          <span>Propostas</span>
        </StepCard>
      </Grid.Column>
      <Grid.Column width={1}>
        <StepCard
          active={step === 3}
          onClick={() => {
            setStep(3);
          }}
        >
          <span>Apólices</span>
        </StepCard>
      </Grid.Column>
      <Grid.Column width={1}>
        <StepCard
          active={step === 4}
          onClick={() => {
            setStep(4);
          }}
        >
          <span>Capitalizações</span>
        </StepCard>
      </Grid.Column>

      <Grid.Column width={1}>
        <StepCard
          active={step === 5}
          onClick={() => {
            setStep(5);
          }}
        >
          <span>Seguro Incêndio</span>
        </StepCard>
      </Grid.Column>

      <Grid.Column width={1}>
        <StepCard
          active={step === 6}
          onClick={() => {
            setStep(6);
          }}
        >
          <span>Sinistros</span>
        </StepCard>
      </Grid.Column>
    </Grid.Row>
  );
};

function renderSection(step: number, estateId?: string) {
  switch (step) {
    case 1:
      return <AnalysisStep estateId={estateId} />;
    case 2:
      return <ProposalsStep estateId={estateId} />;
    case 3:
      return <PolicyStep estateId={estateId} />;
    case 4:
      return <Capitalizationtep estateId={estateId} />;
    case 5:
      return <FireInsuranceStep estateId={estateId} />;
    case 6:
      return <ClaimStep estateId={estateId} />;
    default:
      return null;
  }
}
const Notifications: React.FC<Props> = ({ availableBrokersAndEstates }) => {
  const [selectedEstatesValue, setSelectedEstatesValue] = useState<string>();
  const [step, setStep] = useState(1);
  const estateOptions =
    availableBrokersAndEstates.estates?.map(option => ({
      text: option.text,
      value: option.value.id as string
    })) || [];

  return (
    <NotificationsPageWrapper>
      <Title>Categoria</Title>

      <Subtitle>
        Gerencie o envio dos emails automáticos em cada etapa dos processos do sistema.
      </Subtitle>
      <Divider />
      <Grid.Column width={8}>
        <FieldLabel paddingBottom>Selecionar Imobiliária</FieldLabel>

        <SelectWrapper style={{ marginBottom: 0 }}>
          <Dropdown
            id="realEstatesSelect"
            placeholder="Selecione"
            value={selectedEstatesValue}
            options={estateOptions || []}
            onChange={(_, data) => setSelectedEstatesValue(data.value as string)}
            noResultsMessage={'Carregando...'}
            clearable
            fluid
            search
            selection
          />
        </SelectWrapper>
      </Grid.Column>

      <MenuSelector step={step} setStep={(s: number) => setStep(s)} />
      <div
        style={{
          marginTop: 20
        }}
      >
        {renderSection(step, selectedEstatesValue)}
      </div>
    </NotificationsPageWrapper>
  );
};

const mapStateToProps = (state: iRootState) => ({
  availableBrokersAndEstates: state.availableBrokersAndEstates
});

const mapDispatch = (dispatch: iRootDispatch) => ({
  updateAvailableBrokersAndEstates: (availableBrokers: AvailableBrokersAndEstatesState) =>
    dispatch.availableBrokersAndEstates.updateAvailableBrokersAndEstates(availableBrokers)
});

export default connect(mapStateToProps, mapDispatch)(Notifications);
